import {
	MenuNodeType,
	type MenuNode,
} from '@atlassian/jira-software-context-menu/src/common/types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import {
	MOVE_TO_TOP_MENU_ID,
	MOVE_TO_BOTTOM_MENU_ID,
	MOVE_UP_MENU_ID,
	MOVE_DOWN_MENU_ID,
} from '../../constants.tsx';
import messages from './messages.tsx';

interface MoveToContentProps {
	isMoveToTopActionVisible: boolean;
	isMoveUpActionVisible: boolean;
	isMoveDownActionVisible: boolean;
	isMoveToBottomActionVisible: boolean;
	onMoveToTop: () => void;
	onMoveUp: () => void;
	onMoveDown: () => void;
	onMoveToBottom: () => void;
	setAnnouncement: (message: string) => void;
}

export const useMoveToContent = ({
	isMoveToTopActionVisible,
	isMoveUpActionVisible,
	isMoveDownActionVisible,
	isMoveToBottomActionVisible,
	onMoveToTop,
	onMoveUp,
	onMoveDown,
	onMoveToBottom,
	setAnnouncement,
}: MoveToContentProps): MenuNode[] | null => {
	const { formatMessage } = useIntl();
	const moveToActions = [];

	if (isMoveToTopActionVisible) {
		moveToActions.push({
			type: MenuNodeType.Item,
			id: MOVE_TO_TOP_MENU_ID,
			label: formatMessage(messages.topOfPanel),
			onClick: () => {
				setAnnouncement(formatMessage(messages.movedToTop));
				onMoveToTop();
			},
		});
	}

	if (isMoveUpActionVisible) {
		moveToActions.push({
			type: MenuNodeType.Item,
			id: MOVE_UP_MENU_ID,
			label: formatMessage(messages.up),
			onClick: () => {
				setAnnouncement(formatMessage(messages.movedUp));
				onMoveUp();
			},
		});
	}

	if (isMoveDownActionVisible) {
		moveToActions.push({
			type: MenuNodeType.Item,
			id: MOVE_DOWN_MENU_ID,
			label: formatMessage(messages.down),
			onClick: () => {
				setAnnouncement(formatMessage(messages.movedDown));
				onMoveDown();
			},
		});
	}

	if (isMoveToBottomActionVisible) {
		moveToActions.push({
			type: MenuNodeType.Item,
			id: MOVE_TO_BOTTOM_MENU_ID,
			label: formatMessage(messages.bottomOfPanel),
			onClick: () => {
				setAnnouncement(formatMessage(messages.movedToBottom));
				onMoveToBottom();
			},
		});
	}

	return moveToActions.length > 0 ? moveToActions : null;
};
